import React from "react";
import EditHistoryDetails from "./EditHistoryDetails";
import EditHistoryPanel from "./EditHistoryPanel";


const EditHistoryWrapper = ({style, token, component_id, pattern_id, history_id, component_text_field, activeHistories, component, handleHistoryChange, handleActiveHistory, flag, keyStr, isActive, openUserModal}) => {

    return pattern_id && component_id ? <div style={{
        ...style, fontWeight: "normal", display: "inline-flex",
        justifyContent: 'space-between', width: "100%", minHeight: 30
    }}>
        <EditHistoryDetails
            component={component}
            keyStr={keyStr}
            isActive={isActive}
            openUserModal={openUserModal}
        />
        <EditHistoryPanel
            token={token}
            history_id={history_id}
            pattern_id={pattern_id}
            component_id={component_id}
            handleHistoryChange={handleHistoryChange}
            handleActiveHistory={handleActiveHistory}
            activeHistories={activeHistories}
            component_text_field={component_text_field}
            component={component}
            flag={flag}
        />
    </div> : ""

}

export default EditHistoryWrapper;